import { Component } from "preact";
import { css } from "emotion";
import Checkbox from "../../CheckBox";
class OptionsRefinementMenu extends Component {
  constructor(props) {
    super(props);
  }

  isActive = option => {
    const { active } = this.props;
    if (!active.length) {
      return false;
    }
    const firstActive = active[0];
    if (typeof firstActive === "string" || firstActive instanceof String) {
      return active.indexOf(option) !== -1;
    }
    const found = active.filter(
      item => String(item._id) === String(option._id)
    );
    return found.length;
  };

  render() {
    const { options, update } = this.props;
    const wrapper = css({
      height: 355,
      overflowY: "scroll"
    });
    return (
      <div className={wrapper}>
        {options.map(option => {
          return (
            <Checkbox
              checkbox={true}
              checked={this.isActive(option)}
              click={() => update(option)}
            >
              {option.name ? option.name : option}
            </Checkbox>
          );
        })}
      </div>
    );
  }
}

export default OptionsRefinementMenu;
